import { NgModule } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorI18n } from '../services/PaginatorI18n.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { IconModule } from '../../../assets-common/modules/icon.module';
import { TranslateService } from '@ngx-translate/core';
import { dateFormatsFactory } from './DateFormat';

@NgModule({
  imports: [IconModule],
  providers: [
    { provide: MatPaginatorIntl, useClass: PaginatorI18n },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        ...new MatDialogConfig(),
        disableClose: false,
        hasBackdrop: true,
        width: 'auto',
      } as MatDialogConfig,
    },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    {
      provide: MAT_DATE_FORMATS,
      useFactory: dateFormatsFactory,
      deps: [TranslateService],
    },
  ],
  declarations: [],
})
export class MaterialModule {}
